export const identifiedSymptomQueryKeys = {
  all: ['identified-symptoms'] as const,
  byId: (id: number) => ['identified-symptoms', id] as const,
};
